<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs5>
        <v-progress-circular :size="90"
                             :width="15"
                             :value="percentage(budget.amountSpent, budget.budgetAmount)"
                             :color="colorSelector(percentage(budget.amountSpent, budget.budgetAmount))"
                             style="margin-left:10px;">
          {{ percentage(budget.amountSpent, budget.budgetAmount) }}%
        </v-progress-circular>
      </v-flex>
      <v-flex xs12 sm6> Type: {{budget.budgetType}} </v-flex>
      <v-flex xs12 sm6> Amount: {{budget.budgetAmount}}</v-flex>
      <v-flex xs12 sm6>Account: {{budget.account}} </v-flex>

      <v-flex xs12 sm6 v-if="budget.budget !== 'None'">Budget: {{ budget.budget }}</v-flex>

      <v-flex xs12 sm6>Category: {{ budget.category }}</v-flex>
      <template v-if="budget.Type === 'OneTime'">
        <v-flex xs12 sm6> Date: {{ budget.Date }}</v-flex>
        <v-flex xs12 sm6>Comment: {{ budget.comment }}</v-flex>
      </template>
      <template v-if="budget.Type === 'Recurring'">
        <v-flex xs12 sm6>Repeat Every {{ budget.repeat }} {{ budget.cycle }} &nbsp; <span v-if="budget.period === 'Forever'"> {{ budget.period }} </span><span v-if="budget.period !== 'Forever'">For {{ budget.numberOfCycles }} {{ budget.cycle }}s</span> </v-flex>
        <v-flex xs12 sm6>Goes Off First On: {{ budget.goesOffFirst }}</v-flex>
        <v-flex xs12 sm6>Comment: {{ budget.comment }}</v-flex>
      </template>

    </v-layout>
   
    </v-container>
  </template>

  <script>

    export default {
      props: ['budgetId'],
      data() {
        return {
          budget: []
        }
      },
      computed: {
        percentage: function () {
          return (spent, total) => {
            return (spent / total) * 100
          }
        },
        colorSelector: function () {
          return (val) => {
            if (val < 60) {
              return 'green'
            }
            else if (val >= 60 && val < 90) {
              return 'orange'
            }
            else if (val >= 90) {
              return 'red'
            }
          }
        }
      },
      beforeMount() {
        let bud = this.$store.state.Budgets
        for (let i = 0; i < bud.length; i++) {
          if (bud[i].id === this.budgetId) {
            this.budget = bud[i]
            break
          }
        }
      }
    }
  </script>



// WEBPACK FOOTER //
// src/components/budget/BudgetData.vue